 /* eslint-disable */
 import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import token from '../../helpers/TokenDecoder'

export default {
    GetDashboardMenuItems,
 };
 
 async function GetDashboardMenuItems() {  
     const response = await CommonGet('/api/MainNavMenu/GetMenuModelsByRole', 'roleID=' + parseInt(token.getRoleIDFromToken()));
     return response;
 }

